import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-product-man-settings',
  templateUrl: './product-man-settings.component.html',
  styleUrls: ['./product-man-settings.component.css']
})
export class ProductManSettingsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
